export const UPDATE = 'APP_SHELL_UI_UPDATE'

export const updateUi = update => ({
  type: UPDATE,
  ...update,
})

export const actions = {
  updateUi,
}

export const reducer = (
  state = {
    logoMode: 'auto',
    showHeader: true,
    showSearch: true,
    isInternal: false,
    internalDisplayName: '',
    showHelpCenter: false,
  },
  { type, ...update }
) => {
  if (type === UPDATE) {
    return {
      ...state,
      ...update,
    }
  }

  return state
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/lib/ui.js